<template>
  <div>
    <van-nav-bar
      title="协议"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
    />
    <van-row style="padding-left: 15px; padding-right: 15px; padding-top: 70px" class="p-b-075">
      <div v-html="agreementInfo.agreement"></div>
        <div  v-if="agreementInfo.signAgreementInfos.length > 0">
        <p
          span="24"
          class="text-l f-s-8 p-r-3 m-t-04"
          v-for="(item, i) in agreementInfo.signAgreementInfos"
          :key="i"
          
          >{{ item }}</p
        >
        <div class="f-s-8 m-t-10 f-l-r" style="position:relative">
          <p class="m-b-3">乙方:北京小筑未来教育科技有限公司</p>
          盖章:
        <img :src="compony" style="width:120px;height:120px;position:absolute;left:50px;z-index:50;top:0" />

        </div>
      </div>

    </van-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      agreementInfo: {
        signAgreementInfos: [],
      },
      agreement: "",
      cid: "",
      compony:require("@/assets/imgs/home/company.png")
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.cid =
      this.$route.query.cid == undefined ? null : this.$route.query.cid;
    this.getAgreementDetia();
  },
  methods: {
    getAgreementDetia() {
      let data = {
        id: this.id,
        uid: this.uid(),
      };
      this.ApiNew.Mine.agreemenById(data).then((res) => {
        if (res.retuCode == 5000) {
          this.agreementInfo = res.data;
        }
      });
    },
  },
};
</script>

<style scoped>
</style>